export default "__VITE_ASSET__Ci86iVec__"